import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Motion, spring } from 'react-motion';
import { organisationCreateDynamicPricingOnboarding } from '../../actions';
import { organisationChooseCommitment, organisationAddContactDetails, modalTrigger } from '../../actions';
import Spinner from '../Spinner';
import { SendEventToGoogleTagMngr } from '../../helpers/googleTagManager';

class AddContactInformationAndSendOnboarding extends Component {
    constructor(props) {
        super(props);

        this.name = React.createRef();
        this.email = React.createRef();
        this.phone = React.createRef();
        this.promotionalCode = React.createRef();
        this.state = {
            name: '',
            email: '',
            phone: '',
        };
    }

    handleChange(name, event) {
        let propName = name;
        let input = event.target;
        this.setState((state) => {
            state[propName] = input.value;

            return state;
        });
        this.validateInput(event);
    }
    validateInput(event) {
        let inputValue = event.target.value;
        switch (event.target.id) {
            case 'name':
                this.setState((state) => {
                    state.nameIsValid = inputValue && inputValue.length > 0;
                    return state;
                });
                break;
            case 'email':
                let regex =
                    /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                this.setState((state) => {
                    state.emailIsValid = inputValue && regex.test(inputValue);
                    return state;
                });
                break;
            case 'phone':
                event.target.value = inputValue.replace(/\s/g, '');
                inputValue = event.target.value;
                this.setState((state) => {
                    state.phoneIsValid = inputValue && /^[0-9]*$/.test(inputValue);
                    return state;
                });
                break;
            default:
                break;
        }
    }

    inputsAreValid() {
        return this.state.nameIsValid && this.state.emailIsValid && this.state.phoneIsValid;
    }

    saveContactDetails(event) {
        event.preventDefault();

        this.name.current.querySelector('input').dispatchEvent(new Event('blur'));
        this.email.current.querySelector('input').dispatchEvent(new Event('blur'));
        this.phone.current.querySelector('input').dispatchEvent(new Event('blur'));

        if (this.inputsAreValid()) {
            const contactName = this.name.current.querySelector('input').value;
            const contactEmailAddress = this.email.current.querySelector('input').value;
            const contactPhoneNumber = this.phone.current.querySelector('input').value;
            const promotionalCode = this.promotionalCode.current.querySelector('input').value;

            let organisation = { ...this.props.organisation };
            organisation['contactName'] = contactName;
            organisation['contactEmailAddress'] = contactEmailAddress;
            organisation['contactPhoneNumber'] = contactPhoneNumber;
            organisation['promotionalCode'] = promotionalCode;

            SendEventToGoogleTagMngr('onboarding_price_proposal', {
                companyName: organisation.name,
                organisationNumber: organisation.organisationNumber,
                targetAmount: this.props.offer.turnoverMonth,
            });

            this.props.organisationCreateDynamicPricingOnboarding(
                organisation,
                0,
                this.props.onboarding.provision,
                this.props.onboarding.limitCharge,
                this.props.onboarding.targetAmount,
                this.props.offer.turnoverMonth
            );
        }
    }

    closeModal(event) {
        event.preventDefault();
        this.props.modalTrigger(false);
    }

    render() {
        let { organisation } = this.props;
        let inputClasses = (name) => {
            let className = 'input';
            if (typeof this.state[name] !== 'undefined' && !this.state[name]) {
                className += ' input--error';
            }
            return className;
        };
        return (
            <div className="contacts-info">
                <form className="form form--dark" autoComplete="off">
                    <h2 className="titles title--h2">Innan vi går vidare...</h2>

                    {organisation.addcontactDetailsLoading ? (
                        <div className="commitment-picker__inline-spinner">
                            <Spinner />
                        </div>
                    ) : null}

                    <p className="paragraphs">Fyll i dina kontaktuppgifter.</p>

                    <div className={inputClasses('nameIsValid')} ref={this.name}>
                        <label className="input__label" htmlFor="name">
                            Kontaktperson
                        </label>
                        <input
                            autoComplete="off"
                            value={this.state.name}
                            onInput={this.handleChange.bind(this, 'name')}
                            onBlur={this.validateInput.bind(this)}
                            id="name"
                            type="text"
                            placeholder="För- och efternamn"
                            className="input__field"
                        />
                        {typeof this.state.nameIsValid !== 'undefined' && !this.state.nameIsValid ? (
                            <div className="input__required-information input__required-information--narrow">Fältet är obligatoriskt</div>
                        ) : null}
                    </div>
                    <div className={inputClasses('emailIsValid')} ref={this.email}>
                        <label className="input__label" htmlFor="name">
                            Email
                        </label>
                        <input
                            autoComplete="off"
                            value={this.state.email}
                            onInput={this.handleChange.bind(this, 'email')}
                            onBlur={this.validateInput.bind(this)}
                            id="email"
                            type="email"
                            placeholder="mail@exempel.se"
                            className="input__field"
                        />
                        {typeof this.state.emailIsValid !== 'undefined' && !this.state.emailIsValid ? (
                            <div className="input__required-information input__required-information--narrow">Ange en giltig email-adress</div>
                        ) : null}
                    </div>
                    <div className={inputClasses('phoneIsValid')} ref={this.phone}>
                        <label className="input__label" htmlFor="name">
                            Telefonnummer inkl. riktnummer
                        </label>
                        <input
                            autoComplete="off"
                            value={this.state.phone}
                            onInput={this.handleChange.bind(this, 'phone')}
                            onBlur={this.validateInput.bind(this)}
                            id="phone"
                            type="tel"
                            placeholder="Telefonnummer"
                            className="input__field"
                        />
                        {typeof this.state.phoneIsValid !== 'undefined' && !this.state.phoneIsValid ? (
                            <div className="input__required-information input__required-information--narrow">Ange enbart numeriska värden</div>
                        ) : null}
                    </div>
                    <div className={inputClasses('promotionalCodeIsValid')} ref={this.promotionalCode}>
                        <label className="input__label" htmlFor="name">
                            Om du har fått en <strong>kod</strong> ange den här
                        </label>
                        <input
                            autoComplete="off"
                            value={this.state.promotionalCode}
                            onChange={this.handleChange.bind(this, 'promotionalCode')}
                            id="promotionalCode"
                            type="promotionalCode"
                            placeholder=""
                            className="input__field"
                        />
                    </div>
                    {organisation.error && organisation.error.type === 'ADDCONTACTERROR' ? (
                        <Motion defaultStyle={{ opacity: 0, scale: 0.9, top: 10 }} style={{ opacity: spring(1), scale: spring(1), top: spring(0) }}>
                            {(value) => (
                                <div
                                    className="form__async-status form__async-status--error"
                                    style={{ opacity: value.opacity, top: value.top, transform: `scale(${value.scale})` }}
                                >
                                    {organisation.error.message}
                                </div>
                            )}
                        </Motion>
                    ) : null}

                    <div className="contacts-info-buttons">
                        <button
                            className="buttons button button--full button--action"
                            disabled={this.props.organisation.addcontactDetailsLoading}
                            onClick={this.saveContactDetails.bind(this)}
                            id="send"
                        >
                            Skicka {this.props.organisation.addcontactDetailsLoading}
                        </button>
                        <button
                            className="buttons button button--full button--action"
                            disabled={this.props.organisation.addcontactDetailsLoading}
                            onClick={this.closeModal.bind(this)}
                        >
                            Tillbaka
                        </button>
                    </div>
                </form>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        onboarding: state.modal.dynamicOffer.payload,
        organisation: state.organisation,
        oidc: state.oidc,
        offer: state.offer,
    };
};

AddContactInformationAndSendOnboarding = connect(mapStateToProps, {
    organisationChooseCommitment,
    organisationAddContactDetails,
    modalTrigger,
    organisationCreateDynamicPricingOnboarding,
})(AddContactInformationAndSendOnboarding);

export default AddContactInformationAndSendOnboarding;
